import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/registry.scss';

export class UserRegistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      is_admin: false,
      id: null,
      active: true,
      admin: false,
      username: '',
      email: '',
      password: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  handleCheckBoxChange(e) {
    const checked = e.target.checked;
    this.setState({
      ...this.state,
      [e.target.name]: checked
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    let params = {
      action: 'saveUser',
      token: sessionStorage.getItem('token'),
      username: this.state.username,
      email: this.state.email,
      active: (this.state.active ? 1 : 0),
      admin: (this.state.admin ? 1 : 0)
    };

    if (this.state.password != null && this.state.password != '')
      params['password'] = this.state.password;

    // set id if exists
    if (this.state.id != null && this.state.id != '')
      params['id'] = this.state.id;

    let response = await window.doRequest('POST', params);

    if (response.status) {

      window.alert('Usuário salvo!');
      this.props.history.push('/list/user');

    } else
        window.alert(response.message);
  }

  async verifyIfIsAdmin() {
    let response = await window.doRequest('GET', {
      action: 'isAdmin',
      token: sessionStorage.getItem('token')
    });

    if (response.status)
      this.setState({
        loading: false,
        is_admin: response.content
      })
    else
      window.alert(response.message);
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    const user_info = this.props.location.user_info;
    if (user_info != null) {
      this.setState({
        id: user_info.id,
        active: (user_info.active == 1),
        username: user_info.username,
        email: user_info.email,
        admin: (user_info.admin == 1)
      })
    }

    this.verifyIfIsAdmin();
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="registry">
          <div className="container">
            {
              this.state.loading
                ? <Loader />
                : <div className="user-registry">
                    <h1 className="title">Registro de usuário</h1>
                    <div className="back-btn-container">
                      <button className="back-btn" onClick={(e) => {
                        this.props.history.push('/list/user')
                      }}>
                        Voltar
                      </button>
                    </div>
                    <p>Preencha os dados abaixo.</p>
                    <form onSubmit={(e) => { this.formSubmit(e) }}>

                      <input
                        type="text"
                        placeholder="Nome de usuário"
                        name="username"
                        value={this.state.username}
                        onChange={(e) => {this.handleChange(e)}}
                        required>
                      </input>

                      <input
                        type="mail"
                        placeholder="E-mail"
                        name="email"
                        value={this.state.email}
                        onChange={(e) => {this.handleChange(e)}}
                        required>
                      </input>

                      {
                        (this.state.id == null || this.state.id == '')
                          ? <input
                              type="password"
                              placeholder="Senha (deixar em branco para senha aleatória)"
                              name="password"
                              value={this.state.password}
                              onChange={(e) => {this.handleChange(e)}}>
                            </input>
                          : null
                      }

                      <div className='checkbox-container'>
                        <label>Ativo</label>
                        <input type="checkbox" name="active" checked={this.state.active} onChange={(e) => {this.handleCheckBoxChange(e)}}/>
                      </div>

                      {
                        this.state.is_admin
                          ? <div className='checkbox-container'>
                              <label>Administrador</label>
                              <input type="checkbox" name="admin" checked={this.state.admin} onChange={(e) => {
                                this.handleCheckBoxChange(e);
                                if (e.target.checked)
                                  window.alert('O usuário terá privilégios totais no sistema.');
                              }}/>
                            </div>
                          : null
                      }

                      <div className="btn-container">
                        <button className="btn filled" type="submit">Salvar</button>
                      </div>

                    </form>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default UserRegistry
